import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import DashboardInfo from '@/components/DashboardInfo'
import ActiveEvents from '@/components/events/ActiveEvents'
import EventsArchive from '@/components/events/archive/EventsArchive'
import Event from '@/components/events/Event'
import Country from '@/components/countries/Country'
import CountryGeneralDetails from '@/components/countries/country/GeneralDetails'
import CountryMap from '@/components/countries/country/Map'
import Partners from '@/components/partners/Partners'
import Partner from '@/components/partners/Partner'
import PartnerGeneralDetails from '@/components/partners/partner/GeneralDetails'
import PartnerMap from '@/components/partners/partner/Map'
import PartnerFiles from '@/components/partners/partner/Files'
import Translators from '@/components/translators/Translators'
import Translator from '@/components/translators/Translator'
import TranslatorGeneralDetails from '@/components/translators/translator/GeneralDetails'
import MainMap from '@/components/MainMap'
import Reports from '@/components/reports/Reports'
import DutiesReports from '@/components/reports/Duties'
import StandardsReports from '@/components/reports/Standards'
import ActivityLogs from '@/components/reports/ActivityLogs'
import Users from '@/components/systemSetup/Users'
import Standards from '@/components/systemSetup/Standards'
import SystemSetup from '@/components/systemSetup/SystemSetup'
import Arans from '@/views/Arans'
import AranDetail from '@/views/AranDetail'

Vue.use(Router)

let routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/info',
    name: 'DashboardInfo',
    component: DashboardInfo
  },
  {
    path: '/events',
    name: 'ActiveEvents',
    component: ActiveEvents
  },
  {
    path: '/events/archive',
    name: 'EventsArchive',
    component: EventsArchive
  },
  {
    path: '/events/:id',
    name: 'Event',
    component: Event
  },
  {
    path: '/partners',
    name: 'Partners',
    component: Partners
  },
  {
    path: '/translators',
    name: 'Translators',
    component: Translators
  },
  {
    path: '/countries',
    name: 'Countries',
    component: Country,
  },
  {
    path: '/arans',
    name: 'Arans',
    component: Arans,
  },
  {
    path: '/arans/:id',
    name: 'AranDetail',
    component: AranDetail,
  },
  {
    path: '/countries/:id',
    component: Country,
    children: [
      {
        path: '',
        name: 'CountryGeneralDetails',
        component: CountryGeneralDetails
      },
      {
        path: 'map',
        name: 'CountryMap',
        component: CountryMap
      },
    ]
  },
  {
    path: '/partners/:id',
    component: Partner,
    children: [
      {
        path: '',
        name: 'PartnerGeneralDetails',
        component: PartnerGeneralDetails
      },
      {
        path: 'files',
        name: 'PartnerFiles',
        component: PartnerFiles
      },
      {
        path: 'map',
        name: 'PartnerMap',
        component: PartnerMap
      }
    ]
  },
  {
    path: '/translators/:id',
    component: Translator,
    children: [
      {
        path: '',
        name: 'TranslatorGeneralDetails',
        component: TranslatorGeneralDetails
      }
    ]
  },
  {
    path: '/map',
    name: 'Map',
    component: MainMap
  },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports
  },
  {
    path: '/reports/duties',
    name: 'DutiesReports',
    component: DutiesReports
  },
  {
    path: '/reports/standards',
    name: 'StandardsReports',
    component: StandardsReports
  },
  {
    path: '/reports/activity-logs',
    name: 'ActivityLogs',
    component: ActivityLogs
  },
  {
    path: '/system-setup',
    name: 'SystemSetup',
    component: SystemSetup
  },
  {
    path: '/system-setup/users',
    name: 'Users',
    component: Users
  },
  {
    path: '/system-setup/standards',
    name: 'Standards',
    component: Standards
  },
  // {
  //   path: '/system-setup/users',
  //   name: 'SystemSetup',
  //   component: SystemSetup
  // },
  // {
  //   path: '/system-setup/regions',
  //   name: 'SystemSetup',
  //   component: SystemSetup
  // },
  // {
  //   path: '/system-setup/contacts',
  //   name: 'SystemSetup',
  //   component: SystemSetup
  // },
  // {
  //   path: '/system-setup/checklists',
  //   name: 'SystemSetup',
  //   component: SystemSetup
  // },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
]

export default new Router({
  mode: 'history',
  fallback: false,
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js